import { render, staticRenderFns } from "./HairBuyerDialog.vue?vue&type=template&id=56e60ce4&scoped=true&"
import script from "./HairBuyerDialog.vue?vue&type=script&lang=js&"
export * from "./HairBuyerDialog.vue?vue&type=script&lang=js&"
import style0 from "./HairBuyerDialog.vue?vue&type=style&index=0&id=56e60ce4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56e60ce4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('56e60ce4')) {
      api.createRecord('56e60ce4', component.options)
    } else {
      api.reload('56e60ce4', component.options)
    }
    module.hot.accept("./HairBuyerDialog.vue?vue&type=template&id=56e60ce4&scoped=true&", function () {
      api.rerender('56e60ce4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/Buyer/modules/HairBuyerDialog.vue"
export default component.exports